/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Title3Inputs */

const en_coinvestments_submitticketsize_modal_title3 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket Size`)
};

/**
* | output |
* | --- |
* | "Ticket Size" |
*
* @param {Coinvestments_Submitticketsize_Modal_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_title3 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_title3(inputs)
});
export { coinvestments_submitticketsize_modal_title3 as "coInvestments_submitTicketSize_modal_title" }